import { useContext } from 'react'

import SaveIcon from '@icons/Save'
import SaveActiveIcon from '@icons/SaveActive'
import { useBookmark } from '@models/Bookmark'
import { StoreContext } from '@models/Store'
import { useTranslation } from '@models/Translation'
import { sendError } from '@models/Sentry'

import * as style from './style.module.sass'

type SaveButtonProps = {
  blogId: string
  active: boolean
  type?: 'normal' | 'dark' | 'detail'
  size?: 'small' | 'middium'
}
const SaveButton = ({
  blogId,
  active,
  type = 'normal',
  size = 'middium',
}: SaveButtonProps) => {
  const { entity, action } = useContext(StoreContext)
  const { switchBookmark } = useBookmark()
  const { t } = useTranslation()

  const click = async (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    event.preventDefault()
    try {
      await switchBookmark(blogId)
    } catch (error) {
      sendError(error)
      action.addToasts(t('mypage.failSave'))
    }
  }

  return (
    <button
      onClick={click}
      className={style.button}
      data-active={active}
      data-type={type}
      data-size={size}
      data-show={entity.user !== undefined}
    >
      <SaveIcon />
      <SaveActiveIcon />
      {type === 'detail' && (
        <span>{t(active ? 'mypage.saved' : 'mypage.save')}</span>
      )}
    </button>
  )
}

export default SaveButton
